import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { LinkButton } from '../ui/Button';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
import { telHref } from '../../utils/format';
const ease = [0.23, 1, 0.32, 1] as const;
const tagline = ['Multiservice', 'Montage', 'Vedligehold'];
export function Hero() {
  const {
    settings
  } = useAdminData();
  return <section id="top" className="scroll-mt-24" data-id="element-136" data-mp="qvm7cq8bqwbo">
      <div className="bg-white" data-id="element-137" data-mp="qub4qtqm7um5">
        <div className="mx-auto grid max-w-content items-center gap-10 px-5 py-14 md:py-20 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16 lg:px-8" data-id="element-138" data-mp="qtj6tc9jpksp">
          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.45,
          ease
        }} className="flex justify-center lg:justify-start" data-id="element-139" data-mp="10lysoknyqtiv">
            <h1 data-id="element-140" data-mp="1ajuzj09vb2b6">
              <img src={company.logo} alt={`${settings.companyName} — multiservice, håndværk og vedligehold`} className="h-44 w-auto max-w-full sm:h-52 md:h-64 lg:h-72" data-id="element-141" data-mp="1ah8sd1qw2oth" />
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45,
          ease,
          delay: 0.08
        }} data-id="element-142" data-mp="3vvj3w3ku5goh">
            <ul className="flex flex-wrap items-center gap-x-4 gap-y-2 font-display text-lg font-bold tracking-tight text-ink md:text-2xl" data-id="element-143" data-mp="scza2wmie2rk">
              {tagline.map((item, index) => <li key={item} className="flex items-center gap-4" data-id="element-144" data-mp="infqfoqz24vn" data-mpi={index}>
                  {index > 0 && <span className="h-1.5 w-1.5 rounded-full bg-accent" aria-hidden="true" data-id="element-145" data-mp="enfeqbv9c7sa" />}
                  {item}
                </li>)}
            </ul>

            <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft md:text-xl" data-id="element-146" data-mp="1b6msahjvu296">
              Praktiske løsninger til private og virksomheder. Har du en opgave, stor eller lille, så kontakt
              LYKKEVÆRK og få en uforpligtende snak.
            </p>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-147" data-mp="35kgz699sfkoj">
              <LinkButton href="#kontakt" size="lg" data-id="element-148" data-mp="2qwvz6o87m1ku">
                Få et tilbud
              </LinkButton>
              <LinkButton href={telHref(settings.phone)} variant="secondary" size="lg" data-id="element-149" data-mp="2vu5nu1nry97m">
                Kontakt LYKKEVÆRK
              </LinkButton>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="bg-ink" data-id="element-150" data-mp="2mw3pxuzc7wok">
        <div className="mx-auto flex max-w-content flex-col gap-5 px-5 py-7 md:flex-row md:items-center md:justify-between md:py-8 lg:px-8" data-id="element-151" data-mp="2ms6594x42x2k">
          <a href={telHref(settings.phone)} className="flex items-center gap-3 font-display text-2xl font-bold tracking-tight text-white transition-colors duration-200 ease-smooth hover:text-accent md:text-3xl" data-id="element-152" data-mp="2cvjmqms9ci3p">
            <PhoneIcon className="h-5 w-5 shrink-0 text-accent" strokeWidth={1.75} aria-hidden="true" data-id="element-153" data-mp="b2vneoiqiet7" />
            {settings.phone}
          </a>

          <div className="flex flex-col gap-3 text-[15px] text-white/80 sm:flex-row sm:items-center sm:gap-8" data-id="element-154" data-mp="1qop9uyiysi67">
            <a href={`mailto:${settings.email}`} className="flex items-center gap-2.5 break-all transition-colors duration-200 ease-smooth hover:text-white" data-id="element-155" data-mp="25dvex34hh2m0">
              <MailIcon className="h-4 w-4 shrink-0 text-accent" strokeWidth={1.75} aria-hidden="true" data-id="element-156" data-mp="2ecgt6m2x9vgz" />
              {settings.email}
            </a>
            <p className="flex items-center gap-2.5" data-id="element-157" data-mp="2obo8vfx4q279">
              <ClockIcon className="h-4 w-4 shrink-0 text-accent" strokeWidth={1.75} aria-hidden="true" data-id="element-158" data-mp="2oad7tnv2j8ju" />
              Svar normalt samme dag
            </p>
            <p className="text-white/50" data-id="element-159" data-mp="txewd0xmu5ux">CVR: {settings.cvr}</p>
          </div>
        </div>
      </div>
    </section>;
}